module.exports = __webpack_public_path__ + "img/Ingredients.c0d78692.svg";